<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Salary Structure</h4>
  </div>

  <div class="card-body mt-2">
    <div class="row">
      <div class="col-12 col-md-4">
        <div v-if="salaryTypeData.salary_type_name" class="mb-2">
          <strong>Salary Type:</strong> {{ salaryTypeData.salary_type_name }}
        </div>

        <div v-if="salaryTypeData.scale_amount && salaryTypeData.grade_number" class="mb-2">
          <strong>Salary Grade Scale:</strong>
          {{ salaryTypeData.grade_number }} ({{ salaryTypeData.scale_amount }})
        </div>

        <table class="table table-bordered table-sm mt-3">
          <thead class="table-light">
          <tr>
            <th>Pay Head</th>
            <th class="text-end">Amount</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in payHeadData" :key="index">
            <td>{{ item.pay_head_name }}</td>
            <td class="text-end">{{ item.pay_head_amount }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const emit = defineEmits(['storeContact'])
const props = defineProps({
  items: {
    type: Array
  }
})

const route = useRoute()
const payHeadData = ref([]);
const salaryTypeData = ref({});

const {
  getEmployeeSalaryStructure
} = handleHrPayroll()

const getSalaryStructureData = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&contact_profile_id='+ route.query.contactId
  payHeadData.value = [];
  salaryTypeData.value = {};

  await getEmployeeSalaryStructure(query).then(res => {
    if (!res.status){
      payHeadData.value = [];
      salaryTypeData.value = {};
      return
    }
    payHeadData.value = res.data;
    salaryTypeData.value = res.data[0]
  }).catch(err => {
    console.log(err)
  }).finally(() => {
  })
}

onMounted(() => {
  Promise.all([
    getSalaryStructureData()
  ])
})

</script>
